import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import Dashboard from './Dashboard';
import Map from './Map';
import Alert from './Alert';
import Orders from './Orders';
import Order from './Order';
import LiveChat from '../Live-chat/LiveChat';


class OperationRoom extends Component {
    render () {
        return (
            <Switch>
                <Route path="/operation-room/dashboard" exact component={ Dashboard } />
                <Route path="/operation-room/live-chat" exact component={ LiveChat } />
                <Route path="/operation-room/map" exact component={ Map } />
                <Route path="/operation-room/orders" exact component={ Orders } />
                <Route path="/operation-room/orders/:id" component={ Order } />
                <Route path="/operation-room/map/:alert/:id/:order" component={ Alert } />
            </Switch>
        )
    }
}

export default OperationRoom;



// WEBPACK FOOTER //
// ./src/components/Operation-room/index.js